import React from 'react';

import './Form.css';

const Form = () => {
	return (
		<main>
			<iframe
				src="https://docs.google.com/forms/d/e/1FAIpQLSfbNoniuf9uoIHQlt-EfoVS2R7_gsRznL0CaQeoVD3kapXNYg/viewform?embedded=true"
				frameBorder="0"
				marginHeight="0"
				marginWidth="0"
			>
				Loading…
			</iframe>
		</main>
	);
};

export default Form;
